import { IconSun, IconMoon } from '@tabler/icons-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle = () => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      className="btn btn-icon"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      style={{
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        color: 'var(--text-primary)',
      }}
    >
      {isDark ? (
        <IconSun size={20} />
      ) : (
        <IconMoon size={20} />
      )}
    </button>
  );
};

